module.exports = __webpack_public_path__ + "images/rdr2_rgba(0,0,0,0.7).jpg?v=6496480f8d6063b74f2c703d95f3eaa5";